var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangeModal',{attrs:{"help":"HelpName"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Name, Address, and Landmark")])])
}
var staticRenderFns = []

export { render, staticRenderFns }